import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { I18nService } from './i18n.service';

export interface CartFeedbackEvent {
  message: string;
  tone: 'success' | 'error' | 'info';
  /** When set, shown as toast heading instead of the default tone-based title. */
  title?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CartFeedbackService {
  private readonly eventSubject = new BehaviorSubject<CartFeedbackEvent | null>(null);
  readonly event$ = this.eventSubject.asObservable();

  constructor(private readonly i18n: I18nService) {}

  showSuccess(message = 'Item added to cart.'): void {
    this.eventSubject.next({ message, tone: 'success' });
  }

  showError(message: string, title?: string): void {
    this.eventSubject.next({ message, tone: 'error', title });
  }

  showInfo(message: string, title?: string): void {
    this.eventSubject.next({ message, tone: 'info', title });
  }

  /** Guest tried cart, checkout flow, or wishlist — localized title + body. */
  showGuestShoppingLoginRequired(): void {
    this.showError(this.i18n.t('common.sign_in_required_detail'), this.i18n.t('common.sign_in_required_title'));
  }

  clear(): void {
    this.eventSubject.next(null);
  }
}

